import React, { useState, useEffect, useRef, StrictMode } from "react";
// import parse from "html-react-parser";

import {
  Box,
  Button,
  Text,
  useColorModeValue,
  Textarea,
  useToast,
} from "@chakra-ui/react";

import axios from "../../utils/axios";

import { useSelector } from "react-redux";

const initialState = {
  emailSignature: "",
  file: null,
};

const EmailSignature = () => {
  const toast = useToast();

  const textColor = useColorModeValue("black", "blue.primary");
  const hoverColor = useColorModeValue("black", "blue.primary");
  const borderColor = useColorModeValue("orange.primary", "white.primary");
  const btnColor = useColorModeValue("orange.primary", "white.primary");
  const btnHover = useColorModeValue("orange.secondary", "white.secondary");

  const [state, setState] = useState(initialState);
  const { emailSignature, file } = state;

  const user = useSelector((state) => state.user);

  useEffect(() => {
    setState({
      ...state,
      emailSignature: user.user?.signature?.emailSignature
        ? user.user?.signature?.emailSignature
        : "",
    });
  }, [user]);

  const fileRef = useRef(null);

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      // if (file == null && emailSignature == "") {
      //   toast({
      //     title: "Add Signature data",
      //     status: "danger",
      //     duration: 2000,
      //     isClosable: true,
      //     position: "bottom-left",
      //   });
      // }
      let formData = new FormData();
      formData.append("file", file);
      formData.append("emailSignature", emailSignature);

      const res = await axios.put("/api/user/signature", formData);
    } catch (error) {}
  };

  const options = {
    replace(domNode) {
      if (domNode.attribs && domNode.attribs.class === "remove") {
        return <></>;
      }
    },
  };

  return (
    <Box>
      <Text fontSize="xl" fontWeight={"bold"} mb={3}>
        Email Signature
      </Text>
      <Box>
        <Textarea
          borderRadius="15px"
          mb="24px"
          fontSize="sm"
          type="text"
          placeholder="Enter email signature"
          size="lg"
          borderColor={borderColor}
          name="emailSignature"
          value={emailSignature}
          id="emailSignature"
          onChange={(e) =>
            setState({ ...state, emailSignature: e.target.value })
          }
        />
      </Box>
      {/* <Box mb={3} w="100%" bg={"green"}>
        <Text fontSize="xl" fontWeight={"bold"} mb={3}>
          Signature Preview
        </Text>
        <StrictMode>{parse(emailSignature)}</StrictMode>
      </Box> */}
      <Box mb="50px" mt="20px">
        <label className="signatureEmailBtn" htmlFor="importBulk">
          Add signature identity
        </label>
        <input
          ref={fileRef}
          type="file"
          name="importBulk"
          id="importBulk"
          style={{ display: "none" }}
          // value={emailSignature}
          onChange={(e) => {
            setState({ ...state, file: e.target.files[0] });
          }}
        />
      </Box>
      <Button
        fontSize="15px"
        type="submit"
        bg={btnColor}
        w="100%"
        h="45"
        mb="20px"
        color={textColor}
        borderRadius={"12px"}
        _hover={{
          bg: btnHover,
          color: hoverColor,
        }}
        _active={{
          bg: btnHover,
          color: hoverColor,
        }}
        onClick={handleSubmit}
      >
        Save
      </Button>
    </Box>
  );
};

export default EmailSignature;
